function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './providers.scss';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'researcher/components/Loading';
import useRepeater from 'researcher/hooks/use-repeater';
import Redirect from 'shared/components/Redirect';
import featureEnabled from 'shared/helper/feature';
import { T, useTranslate } from 'shared/helper/translate';
import { checkWeChatLogin, startWeChatLogin } from '../actions';
var WeChatLogin = function WeChatLogin(_ref) {
  var _ref$source = _ref.source,
    source = _ref$source === void 0 ? 'wechat' : _ref$source,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'btn btn-primary btn-squared' : _ref$className,
    _ref$isInLogin = _ref.isInLogin,
    isInLogin = _ref$isInLogin === void 0 ? false : _ref$isInLogin,
    img = _ref.img;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    qrCodeRequested = _useState2[0],
    setQrCodeRequested = _useState2[1];
  var qrCodeUrl = useSelector(function (_ref2) {
    var authentication = _ref2.authentication;
    return authentication.qrCodeUrl;
  });
  var redirect = useSelector(function (_ref3) {
    var authentication = _ref3.authentication;
    return authentication.redirect;
  });
  var showLoading = useSelector(function (_ref4) {
    var authentication = _ref4.authentication;
    return authentication.status.loading;
  }) && qrCodeRequested;
  var _useRepeater = useRepeater({
      fn: function fn() {
        return handleCheckWeChatLogin();
      },
      numberOfSecondsBetweenCalls: 2,
      numberOfTimesToExecute: 30
    }),
    startPolling = _useRepeater.start,
    stopPolling = _useRepeater.stop;
  var weChatSsoEnabled = featureEnabled('wechat_sso');
  var showError = !showLoading && qrCodeRequested && !qrCodeUrl;
  var handleShowQrCode = function handleShowQrCode() {
    setQrCodeRequested(true);
  };
  var handleCheckWeChatLogin = function handleCheckWeChatLogin() {
    dispatch(checkWeChatLogin()).then(function (_ref5) {
      var error = _ref5.error;
      if (error) {
        stopPolling();
      }
    });
  };
  useEffect(function () {
    if (qrCodeRequested) {
      dispatch(startWeChatLogin()).then(function (_ref6) {
        var error = _ref6.error;
        if (!error) {
          startPolling();
        }
      });
    }
  }, [qrCodeRequested]);
  if (!weChatSsoEnabled) {
    return null;
  }
  if (redirect) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirect
    });
  }
  if (qrCodeUrl) {
    return /*#__PURE__*/React.createElement("img", {
      src: qrCodeUrl,
      alt: "qr code",
      width: "150px",
      height: "150px"
    });
  }
  if (showLoading) {
    return /*#__PURE__*/React.createElement(Loading, {
      text: "fetching qr code"
    });
  }
  if (showError) {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "display-2",
      icon: "fa-solid fa-circle-exclamation"
    });
  }
  var button = /*#__PURE__*/React.createElement("button", {
    "aria-label": t('wechat'),
    className: className,
    onClick: handleShowQrCode,
    type: "button"
  }, isInLogin ? /*#__PURE__*/React.createElement("img", {
    alt: "Sign up with wechat",
    src: img,
    height: "20"
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-brands fa-weixin"
  }), /*#__PURE__*/React.createElement("span", {
    className: "provider-icon-spacer"
  }), /*#__PURE__*/React.createElement(T, {
    source: source
  }), " ", isInLogin && /*#__PURE__*/React.createElement("span", null, "WeChat"));
  if (isInLogin) {
    return button;
  }
  return /*#__PURE__*/React.createElement("li", {
    key: "wechat-login",
    className: "d-inline-block m-2 p-0"
  }, button);
};
export default WeChatLogin;